export default "__VITE_ASSET__D9rShSPA__"